import React, { useState, useContext, useEffect, useRef } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import selectors from '@state/selectors';
import {IProps, IState, IFileResponse} from './types';
import * as S from './styles';
import Button from '@components/Button';
import SearchImages from './SearchImages';
import { Context } from "routes/private/Editor/Context";
import { IElement, IImageAttributes, IShapeCircleAttributes, IShapeCommonAttributes, IShapeEllipseAttributes, IShapeLineAttributes, IShapeRectangleAttributes, IShapeRhombusAttributes, IShapeStarAttributes, IShapeTriangleAttributes, IShapeTypes, ITextAttributes } from '@routes/private/Editor/types';
import { findElementsByIds } from '@utils/editor';
import { IBrandImage } from '@state/brandsImages/types';
import { storageAccountName, containerNameBrands, containerName,containerNameExternals } from '@storage/azure-storage-blob';
import { AuthContext } from '@utils/DOIgnition/AuthContext';
import ToolTip from '@components/Tooltip';
import SimilarVehicles from './vehicles';
import SimilarLogos from './logos';
import { ITemplate } from '@state/templates/types';
import { getOEMName } from 'utils/editor'
import { sendFile, copyFile } from '@utils/cloudStorage';
import { IImageList } from '../ImagePicker/types';
import { IUserFiles } from '@state/userFiles/types';
import { containImage } from '@utils/render';
import actions from '@state/actions';
import SimilarBackgrounds from './backgrounds';
import SimilarStocks from './stocks';

const uuid = require('react-uuid');

const SimilarImages:React.FC<IProps> = (props) => {  
  const authContext = useContext(AuthContext);
  const dsConfig = useSelector(selectors.dsConfig.getDSConfig);
  let context = useContext(Context);  
  const [loadingImage, setLoadingImage] = useState(false);
  const [imageAttr, setImageAttr]= useState<IImageAttributes>();
  const urlBrand =`https://${storageAccountName}.blob.core.windows.net/${containerNameBrands}`;
  const urlFiles = `https://${storageAccountName}.blob.core.windows.net/${containerName}`
   let { editorStatus, data,selectDescribe, onCommandChange} = useContext(Context);
   const oem = (context.entityInformation as ITemplate).tags.oem;
   const oemName = getOEMName(oem,dsConfig)   
   const loadFromBrand = editorStatus?.currentPicker==="BrandLibrary";
   const [fileResponse, setFileResponse] = useState<IFileResponse>();



  const dispatch = useDispatch();
  
  useEffect(() => {        
    const elements = findElementsByIds(data, editorStatus.selectedElementsId);
    if (elements && elements.length > 0) {            
        setImageAttr((elements[0]!.attributes as IImageAttributes))                              
    }    
  }, [data, editorStatus.selectedElementsId]);
          




  const handleSearchClick=()=>{
    //context.onShowPicker(undefined);
    context.onShowSearchImages(true);


  }


  
  const handleSelectImage=(data:IBrandImage)=>{
             
    setLoadingImage(true)        
    try {      
      if (data.srcImage.startsWith("http") && !data.srcImage.startsWith(urlFiles))
        getImage(data);        
      else
          selectImage(data);                        
    } catch(error) {
      setLoadingImage(false)        
      console.error(error);
    }
  
  }

  const selectImage=(data:IBrandImage)=>{
             
    try {
       
        let oldscr='';
        const elements = findElementsByIds(context.data, context.editorStatus.selectedElementsId);
        if (elements && elements.length > 0) 
          oldscr = (elements[0]?.attributes as IImageAttributes).srcImage??"";                           
          const ids: string[] = context.editorStatus.selectedElementsId;

          let url = `${urlFiles}/${data.srcImage}`
          if (data.brandId!==undefined && data.brandId!==null)
            url = `${urlBrand}/${data.brandId}/${data.imageType.toLowerCase()}/${data.srcImage}`
                              

          var img = new Image();
          img.src = url;
          img.onload = (e) => {         
            
            let values;
            if (data.imageType=="BACKGROUNDS" || data.imageType=="STOCKS")                          
              values = Array(ids.length).fill({srcImage: data.srcImage, brandId: data.brandId, brandImageType: data.imageType, brandData:data.types, width: img.width, height: img.height, newSrcImage: data.srcImage});
            else
              values = Array(ids.length).fill({srcImage: data.srcImage, brandId: data.brandId, brandImageType: data.imageType, brandData:[data.year??"",data.make??"",data.model??"",data.trim??"", data.types && data.types.length?data.types[0].value??"":""], width: img.width, height: img.height, newSrcImage: data.srcImage});
            
            context.onCommandChange("srcImage", undefined, ids, values);

            if (context.searchImages)
            {              
              context.onShowSubPicker(undefined);
            }
            
          } 
          img.onerror = (e)=>{
            console.error(e);
          }
               
          setLoadingImage(false)   
        
          
    } catch(error) {
      console.error(error);
    }
  
  }

  const renderBrandImageData =() =>{

    if (context.editorStatus.subPickerProperties?.category.toUpperCase().includes("VEHICLE"))
    {
      if (imageAttr &&  imageAttr.brandData && imageAttr.brandData.length>3)
        return (`${imageAttr.brandData[0]}, ${imageAttr.brandData[1]}, ${imageAttr.brandData[2]}, ${imageAttr.brandData[3]}`)
    }
    if (context.editorStatus.subPickerProperties?.category.toUpperCase().includes("LOGO"))
    {
      if (oem!==undefined)      
        return (`${oemName} Logos`)
      else
        return (`Logo`)
    }    
    if (context.editorStatus.subPickerProperties?.category.toUpperCase().includes("BACKGROUND"))
    {
      if (oem!==undefined)      
        return (`${oemName} Backgrounds`)
      else
        return (`Background`)
    }    
    if (context.editorStatus.subPickerProperties?.category.toUpperCase().includes("STOCK"))
    {
      if (oem!==undefined)      
        return (`${oemName} Stocks`)
      else
        return (`Stock`)
    }    
    return ""
  }


  const renderSimilarList =()=>{
    if (imageAttr)
    {
      if (context.editorStatus.subPickerProperties?.category.toUpperCase().includes("LOGO"))
      {
        return (      
          <SimilarLogos attributes={imageAttr} oem={oem} oemName={oemName} oemType={context.editorStatus.subPickerProperties?.category}  onSelect={(data:IBrandImage)=> handleSelectImage(data)}
          ></SimilarLogos>
          )
      }
      if (context.editorStatus.subPickerProperties?.category.toUpperCase().includes("VEHICLE"))
      {
        return (      
          <SimilarVehicles attributes={imageAttr} loadingImage={loadingImage} onSelect={(data:IBrandImage)=> handleSelectImage(data)}
          ></SimilarVehicles>
          )
       }
     
      if (context.editorStatus.subPickerProperties?.category.toUpperCase().includes("BACKGROUND"))
      {
        return (      
          <SimilarBackgrounds attributes={imageAttr} oem={oem} oemName={oemName} onSelect={(data:IBrandImage)=> handleSelectImage(data)}
          ></SimilarBackgrounds>
          )
      }
      if (context.editorStatus.subPickerProperties?.category.toUpperCase().includes("STOCK"))
      {
        return (      
          <SimilarStocks attributes={imageAttr} oem={oem} oemName={oemName} onSelect={(data:IBrandImage)=> handleSelectImage(data)}
          ></SimilarStocks>
          )
      }



    }
  }

  const getCategory =()=>{
      if (context.editorStatus.subPickerProperties?.category.toLocaleLowerCase().includes("logo")) return 'logo';
      else if (context.editorStatus.subPickerProperties?.category.toLocaleLowerCase().includes("vehicle")) return 'vehicle';
      else if (context.editorStatus.subPickerProperties?.category.toLocaleLowerCase().includes("background")) return 'background';
      else if (context.editorStatus.subPickerProperties?.category.toLocaleLowerCase().includes("stock")) return 'stock';
      else return undefined;
  }



  async function getImage(brandImage:IBrandImage){          
    const data: any = await getExternalImage(brandImage.srcImage)         
    if (data) 
    {
      brandImage.srcImage= data;
      selectImage(brandImage);      
    }
  }

  const getExternalImage = (url:string) => {    
    
    return new Promise((resolve, reject) => {      
      dispatch(actions.brandsImages.getExternalImage(url, (result, error) => {                             
        if (error) reject(error)
        else {                 
          resolve(result)}

      }))
    });
  }



  return (
    <>
    <S.Root>
        <S.SimilarTitle>
          Similar Images:
        </S.SimilarTitle>
        <ToolTip
          tip = {renderBrandImageData()}
        >
        <S.HelpText>
        {renderBrandImageData()}
        </S.HelpText>          
        </ToolTip>
        <div style = {{paddingLeft:'15px'}}>
        <Button                 
              label="SEARCH BRAND LIBRARY"
              style={{hoverBackgroundColor: "#344a70", backgroundColor: "#19325d", width: 232, height: 36, boxSizing: 'border-box', marginTop:7}}
              labelStyle={{color: "white", fontWeight: '500'}}
              onClick={handleSearchClick}
        />
        </div>
        {
          renderSimilarList()
        }
    
      </S.Root>
    {
      context.searchImages &&    
      <SearchImages open={context.searchImages} setOpen={(show: boolean)=>{context.onShowSearchImages(show)}} onSelect={(data:IBrandImage)=>{handleSelectImage(data)}} category={getCategory()} loadingImage={loadingImage} />
    }
    </>
  );
}

export default SimilarImages;